import { z } from 'zod';
import { ErrorResponseSchema } from '../../common/base';

/**
 * Request schema for presigned URL generation
 * POST /api/user/upload-photo
 */
export const UploadPhotoRequestSchema = z.object({
  /** Number of presigned URLs to generate (default: 2 for original + thumbnail) */
  imageCount: z.number().int().min(1).max(5).optional().default(2),
});

export type UploadPhotoRequest = z.infer<typeof UploadPhotoRequestSchema>;

/**
 * Success response schema for upload-photo endpoint
 */
const UploadPhotoSuccessSchema = z.object({
  success: z.literal(true),
  /** Array of presigned URLs for uploading images */
  presignedUrls: z.array(z.string().url()),
  /** User ID */
  userId: z.number(),
});

export type UploadPhotoSuccess = z.infer<typeof UploadPhotoSuccessSchema>;

/**
 * Combined response schema for upload-photo endpoint
 * Discriminated union based on success field
 *
 * @example
 * ```typescript
 * const response = UploadPhotoResponseSchema.parse(data);
 * if (response.success) {
 *   // Upload images to presigned URLs
 *   for (const url of response.presignedUrls) {
 *     await uploadToUrl(url, imageData);
 *   }
 * }
 * ```
 */
export const UploadPhotoResponseSchema = z.discriminatedUnion('success', [
  UploadPhotoSuccessSchema,
  ErrorResponseSchema,
]);

export type UploadPhotoResponse = z.infer<typeof UploadPhotoResponseSchema>;
